import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "modalFrame", "modalTitle"]

  filter(event) {
    const trigger = event.currentTarget
    const cat = trigger.dataset.category
    // Chip styling differs per gallery: templates use .rt-chip, examples .rx-chip.
    const chipClass = trigger.classList.contains("rx-chip") ? "rx-chip" : "rt-chip"
    this.element.querySelectorAll("." + chipClass).forEach(t => {
      const on = t === trigger
      t.setAttribute("aria-pressed", String(on))
      t.classList.toggle(chipClass + "--on", on)
    })
    // Filterable items carry data-category and are NOT chips. Both galleries
    // render one continuous grid now — the per-category <section>s are gone, so
    // data-category lives on each card and hiding is per-card again. The guard
    // below is what keeps the chips themselves (which also carry
    // data-category) from hiding each other.
    this.element.querySelectorAll("[data-category]").forEach(el => {
      if (el.classList.contains("rt-chip") || el.classList.contains("rx-chip")) return
      el.hidden = !(cat === "all" || el.dataset.category === cat)
    })
  }

  preview(event) {
    const id = event.currentTarget.dataset.templateId
    if (this.hasModalTitleTarget) this.modalTitleTarget.textContent = event.currentTarget.dataset.templateName || ""
    this.modalFrameTarget.src = `/dashboard/resume-templates/${id}/preview`
    this.modalTarget.hidden = false
    document.body.style.overflow = "hidden"
    this.modalTarget.querySelector(".rt-modal__close")?.focus()
  }

  closePreview() {
    this.modalTarget.hidden = true
    this.modalFrameTarget.src = "about:blank"
    document.body.style.overflow = ""
  }

  closeOnEsc(e) {
    if (e.key === "Escape" && this.hasModalTarget && !this.modalTarget.hidden) this.closePreview()
  }
}
